import { capitalizeString } from "../capitalizeString";
import { ProviderType } from "../../../services/cloudchipr.api";

const providerNames: Map<ProviderType, string> = new Map([
  ["aws", "account"],
  ["gcp", "project"],
  ["azure", "subscription"],
]);

const providerTitles: Map<ProviderType, string> = new Map([
  ["aws", "AWS"],
  ["gcp", "GCP"],
  ["azure", "Azure"],
]);

export const getProviderName = (
  provider: ProviderType,
  options?: {
    title?: boolean;
    plural?: boolean;
    nameAndTitle?: boolean;
    capitalize?: boolean;
    uppercase?: boolean;
  },
) => {
  let providerName = providerNames.get(provider) ?? "";

  if (options?.title) {
    providerName = providerTitles.get(provider) ?? "";
  }

  if (options?.capitalize) {
    providerName = capitalizeString(providerName);
  }
  if (options?.plural) {
    providerName = providerName + "s";
  }
  if (options?.nameAndTitle) {
    providerName = `${providerTitles.get(provider)} ${providerName}`;
  }
  if (options?.uppercase) {
    providerName = providerName.toUpperCase();
  }

  return providerName;
};
